import React from 'react';
import './styles.css';
import { useHistory } from 'react-router';
import { Row, Col, Button, Popover } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleDown } from '@fortawesome/free-solid-svg-icons';
import {
  PageLayout,
  DividerContainer,
  ItemList,
  ButtonBackData,
  BupSpinner,
  ErrorMessage,
} from '@BUP/components';
import { useBraveUpSurveysApi } from '@BUP/hooks';
import ImagePaso1 from '@BUP/assets/Images/Data/data_paso(1).png';
import ImagePaso2 from '@BUP/assets/Images/Data/data_paso(2).png';
import ImagePaso3 from '@BUP/assets/Images/Data/data_paso(3).png';
import ImagePaso4 from '@BUP/assets/Images/Data/data_paso(4).png';
import ImagePaso5 from '@BUP/assets/Images/Data/data_paso(5).png';
import ImagePaso6 from '@BUP/assets/Images/Data/data_paso(6).png';
import GuiaPaso3 from '@BUP/assets/Documents/Data/guia_orientacion_toma_de_datos.pdf';
import GraficasPaso4 from '@BUP/assets/Documents/Data/Recursos_BRAVE-UP_DATA.zip';
import { useTranslation } from 'react-i18next';

const DataActivationStepsPage = () => {
  const history = useHistory();
  const { isLoadingSurvey, survey, errorSurvey } = useBraveUpSurveysApi();
  const [t] = useTranslation();

  const contentStep3 = (
    <div>
      <p>{t('pages.data.activationSteps.popoverText1')}</p>
    </div>
  );

  const contentStep4 = (
    <div>
      <p>{t('pages.data.activationSteps.popoverText2')}</p>
    </div>
  );

  return (
    <PageLayout>
      <ButtonBackData onClick={() => history.goBack()} />
      <DividerContainer title={t('pages.data.activationSteps.dividerTitle')} />
      {isLoadingSurvey ? (
        <BupSpinner size="large" />
      ) : errorSurvey ? (
        <ErrorMessage />
      ) : (
        <>
          <p className="welcome-paragraph">
            {t('pages.data.activationSteps.welcomeText')}
          </p>
          <ItemList
            className="item-list"
            count="1"
            src={ImagePaso1}
            title={t('pages.data.activationSteps.step1Title')}
            description={t('pages.data.activationSteps.step1Description')}
          />
          <ItemList
            count="2"
            src={ImagePaso2}
            title={t('pages.data.activationSteps.step2Title')}
            description={t('pages.data.activationSteps.step2Description')}
          />
          <ItemList
            count="3"
            src={ImagePaso3}
            title={t('pages.data.activationSteps.step3Title')}
            description={t('pages.data.activationSteps.step3Description')}
            download={
              <Popover content={contentStep3}>
                <a target="_blank" href={GuiaPaso3} rel="noreferrer">
                  <FontAwesomeIcon
                    className="download-icon"
                    icon={faArrowCircleDown}
                  />
                </a>
              </Popover>
            }
          />
          <ItemList
            count="4"
            src={ImagePaso4}
            title={t('pages.data.activationSteps.step4Title')}
            description={t('pages.data.activationSteps.step4Description')}
            download={
              <Popover content={contentStep4}>
                <a href={GraficasPaso4}>
                  <FontAwesomeIcon
                    className="download-icon"
                    icon={faArrowCircleDown}
                  />
                </a>
              </Popover>
            }
          />
          <ItemList
            count="5"
            src={ImagePaso5}
            title={t('pages.data.activationSteps.step5Title')}
            description={t('pages.data.activationSteps.step5Description')}
          />
          <ItemList
            count="6"
            src={ImagePaso6}
            title={t('pages.data.activationSteps.step6Title')}
            description={t('pages.data.activationSteps.step6Description')}
          />
          {!survey ? (
            <>
              <Row justify="end">
                <Col span={8}>
                  <Button
                    type="primary"
                    size="large"
                    className="activationSteps_request-button"
                    onClick={() =>
                      history.push(
                        '/data/instruments/request-activation/start-activation'
                      )
                    }
                  >
                    {t('pages.data.activationSteps.activationButtonText1')}
                    <br />
                    {t('pages.data.activationSteps.activationButtonText2')}
                  </Button>
                </Col>
              </Row>
            </>
          ) : null}
          <ButtonBackData onClick={() => history.goBack()} />
        </>
      )}
    </PageLayout>
  );
};

export default DataActivationStepsPage;
